import { render, staticRenderFns } from "./MplsOverLteWizard.vue?vue&type=template&id=5d7897a2&"
import script from "./MplsOverLteWizard.vue?vue&type=script&lang=js&"
export * from "./MplsOverLteWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports